/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:edf38df4-4247-4862-9fdd-cea2cd3db522",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_SjNeVIA2v",
    "aws_user_pools_web_client_id": "7dfvmnca9p7a9qvvnae4he3apf",
    "oauth": {}
};


export default awsmobile;
